import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TimeEndedPopup({ setloaderType }) {
    const { t } = useTranslation("clientOnDemand");
    const navigate = useNavigate();
    // const { id  } = useSelector((state) => state.user.user);



    const navigatePage = () => {
        window.loadModal2("#TimeEndedPopup", "hide")
        setTimeout(() => {
            navigate('/booking')
        }, 100)

    }

    const exitFromHere  = () => {
        window.loadModal2("#TimeEndedPopup", "hide")

   }
    return (
        <div>
            <div
                id="TimeEndedPopup"
                class="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                data-backdrop="static"
            >
                <div class="modal-dialog modal-lg modal-dialog-preview text-center">
                    <div class="modal-content ">
                        <div className="no-app-fount-box">

                            <p className="font-size-18">{t("timeEnded.noMatch")}


                            </p>


                            <br />
                            <p className="font-size-18">{t("timeEnded.checkBack")}
                            </p>
                            <div className="d-flex align-items-center justify-content-around">

                                <div
                                 onClick={exitFromHere}

                                    className="width-215-px white-border pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                                >
                                    {t("timeEnded.futureEvents")}
                                </div>
                                <div
                                    onClick={navigatePage}
                                    className="width-215-px white-bg-btn pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                                >
                                    {t("timeEnded.bookInAdvance")}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
